<template>
  <div v-if="$apollo.queries.eventCategories.loading" class="wrapper">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
  <v-container v-else fluid>
    <PageContent height="100" padding="0px 10px 0px 0px">
      <v-list dense style="background: unset">
        <v-row>
          <v-col
            cols="4"
            v-for="(navItem, navItemIndex) in navItems"
            :key="`${navItemIndex}-${navItemIndex}`"
          >
            <v-card
              v-bind="$options.cardStyle" :to="navItem.to || null"
            >
              <v-card-text class="text-center text-h5" v-text="navItem.text" /> </v-card
            ></v-col>
        </v-row>
      </v-list>
    </PageContent>
  </v-container>
</template>

<script>
import { navListDashboard } from '@/services/nav/nav-items'
import eventsCategoriesQuery from '@/services/gql/types/EventCategories/queries/eventCategories.gql'
import PageContent from '@/components/page-content/PageContent.vue'

const cardStyle = {
  height: 150,
  maxHeight: 150,
  cols: 4,
  outlined: true,
  hover: true,
  dense: true,
  class: 'd-flex justify-center align-center'
}

export default {
  name: 'PageDashboard',
  components: { PageContent },
  cardStyle,
  metaInfo () {
    return {
      title: 'Добро пожаловать!'
    }
  },
  data () {
    return {
      eventCategories: []
    }
  },
  computed: {
    navItems () {
      return navListDashboard
        .filter(navItem => this.$permissionsHandler(navItem.permissions))
        .map(item => {
          if (item.key) item.text = this.$t(`pages-name.parent.${item.key}`)
          return item
        })
        .filter(item => item.text)
    }
  },
  apollo: {
    eventCategories: {
      fetchPolicy: 'network-only',
      query: eventsCategoriesQuery,
      pollInterval: 30000,
      variables: {
        where: {}
      },
      result ({ data }) {
        this.eventCategories = data?.eventCategories?.list
      }
    }
  }
}
</script>
<style>
.wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
